import { useMemo } from 'react';
import { useGetAccountGroupCategoriesQuery } from '@/store/accountsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { AccountBase } from '@/models/AccountViewModel';
import { formatGroups } from '@/utils/account';
import { UseAccountDataReturn } from '@/components/flyouts/types';

export const useAccountData = (
  account: AccountBase | null,
): UseAccountDataReturn => {
  const {
    data: allGroups,
    isLoading,
    error,
    isFetching,
  } = useGetAccountGroupCategoriesQuery(account ? undefined : skipToken);

  const dynamicFields = useMemo(() => {
    const records = allGroups?.Records ?? [];
    if (!account || !records) {
      return [] as { label: string; value: string }[];
    }
    return formatGroups(account, records);
  }, [account, allGroups]);

  return {
    dynamicFields,
    isLoading: isLoading || isFetching,
    hasError: !!error,
    error,
  };
};
